import {
    Component,
    EventEmitter,
    Inject,
    Input,
    LOCALE_ID,
    OnInit,
    Output, QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {TabViewModule} from "primeng/tabview";
import {ChipsModule} from "primeng/chips";
import {FormsModule} from "@angular/forms";
import {AttributeValue} from "../../dto/AttributeValue";
import {AutoCompleteModule} from "primeng/autocomplete";
import {DropdownModule} from "primeng/dropdown";
import {Pages} from "../../dto/Pages";
import {NgForOf, NgIf} from "@angular/common";
import {UploadAdapter} from "../../services/UploadAdapter";
import {NgxSuneditorComponent, NgxSuneditorModule} from "ngx-suneditor";
import {EditorBO} from "../../bo/EditorBO";
import {PageSection} from "../../dto/PageSection";
import {SplitButtonModule} from "primeng/splitbutton";
import {ConfirmationService, MenuItem, MessageService} from "primeng/api";
import {SectionItem} from "../../dto/SectionItem";
import {DialogModule} from "primeng/dialog";
import {ImageManagerComponent} from "../componnts/image-manager/image-manager.component";
import {UploadFile} from "../../dto/UploadFile";
import {RestBackendService} from "../../services/rest-backend.service";
import {Router} from "@angular/router";
import {GlobalService} from "../../services/global.service";
import {ConfigService} from "../../services/config.service";
import {ColorPickerModule} from "primeng/colorpicker";

import {AccordionModule} from "primeng/accordion";
import {log} from "@angular-devkit/build-angular/src/builders/ssr-dev-server";
import {InputSwitchModule} from "primeng/inputswitch";
import {Table} from "primeng/table";
import {Attribute} from "../../dto/Attribute";
import {SafeHtmlPipePipe} from "../../pips/safe-html-pipe.pipe";
import {PaginatorModule} from "primeng/paginator";


@Component({
    selector: 'app-admin-edit-page',
    standalone: true,
    imports: [
        TabViewModule,
        ChipsModule,
        FormsModule,
        AutoCompleteModule,
        DropdownModule,
        NgForOf,
        NgxSuneditorModule,
        SplitButtonModule,
        NgIf,
        DialogModule,
        ImageManagerComponent,
        ColorPickerModule,
        AccordionModule,
        InputSwitchModule,
        SafeHtmlPipePipe,
        PaginatorModule
    ],
    templateUrl: './admin-edit-page.component.html',
    styleUrl: './admin-edit-page.component.css'
})
export class AdminEditPageComponent implements OnInit {

    @Input() page: Pages = new Pages();
    @Output() savePageEvent = new EventEmitter();
    @Output() cancelSaveEvent = new EventEmitter();
    newAttributeValue: AttributeValue = new AttributeValue();
    attributeList: Array<string> = new Array<string>();
    editorBO: EditorBO = new EditorBO();
    @ViewChildren("suneitor") suneitor_TextList: QueryList<NgxSuneditorComponent> | undefined;
    sectionHeaderItems: Array<MenuItem[]> = new Array<MenuItem[]>();
    selectedSection: PageSection;
    displayImageCenter: boolean = false;
    displayVideoCenter: boolean = false;
    displayInnerHtml: boolean = false;
    imgManagerTemp: UploadFile = new UploadFile();
    videoSrcTemp: string = "";
    selectPhotoType: string = "photo";
    sectionItemIndex: number = 0;
    @Input() otherFieldsTitle: string[];
    load: boolean = false;
    htmlEditorOptions = {theme: 'vs-dark', language: 'html'};
    accordionTemp: any = {};
    editItem:SectionItem = null;
    protected readonly innerHeight = innerHeight;


    constructor(protected restBack: RestBackendService,
                public route: Router,
                protected messageService: MessageService,
                protected confirmationService: ConfirmationService,
                public global: GlobalService,
                protected config: ConfigService,
                @Inject(LOCALE_ID) public locale: string) {


    }

    fillItemsMenu(i) {

        let sectionHeaderItems = [

            {
                label: $localize`:@@Title:Title`,
                icon: 'pi pi-pencil ',
                command: () => {
                    this.addNewItem(i, 'TITLE')
                }
            },
            {
                label: $localize`:@@Text:Text`,
                icon: 'pi pi-align-left ',
                command: () => {
                    this.addNewItem(i, 'TEXT')
                }
            },

            {
                label: $localize`:@@Photo:Photo`,
                icon: 'pi pi-image',
                command: () => {
                    this.addNewItem(i, 'PHOTO')
                }
            },
            {
                label: $localize`:@@Video:Video`,
                icon: 'pi pi-video',
                command: () => {
                    this.addNewItem(i, 'VIDEO')
                }
            },
            {
                label: $localize`:@@author:author`,
                icon: 'pi pi-pencil',
                command: () => {
                    this.addNewItem(i, 'AUTHOR')
                }
            },
            {
                label: 'HTML',
                icon: 'pi pi-code',
                command: () => {
                    this.addNewItem(i, 'HTML')
                }
            },
            {
                label: $localize`:@@Separator:Separator`,
                icon: 'pi pi-minus',
                command: () => {
                    this.addNewItem(i, 'SEPARATOR')
                }
            },
            {
                label: 'Accordion',
                icon: 'pi pi-align-justify',
                command: () => {
                    this.addNewItem(i, 'ACCORDION')
                }
            },
            {
                label: 'InnerHtml',
                icon: 'pi pi-code',
                command: () => {
                    this.addNewItem(i, 'INNER')
                }
            }
        ];
        return sectionHeaderItems;
    }

    ngOnInit(): void {
        this.loadListAttribute({query: ''})
        if (this.page.pageSections == null || this.page.pageSections.length < 1) {
            let sec = new PageSection()
            sec.priority = 0
            this.page.pageSections = new Array<PageSection>();
            this.page.pageSections.push(sec);
            this.sectionHeaderItems[0] = this.fillItemsMenu(0);
        } else {
            for (let i = 0; i < this.page.pageSections.length; i++) {
                this.sectionHeaderItems[i] = this.fillItemsMenu(i);
            }
        }

        setTimeout(() => {
            // for (let editor of this.suneitor_TextList.toArray()) {
            //     this.editorBO = new EditorBO();
            //     editor.options = this.editorBO.editorOptionsLite;
            //     editor.setContents( 'test')
            // }
            this.load = true;
        }, 500)


        // this.editor.builtinPlugins = [
        //     Table,
        //     // other plugins
        // ];
        //
        // this.editor.defaultConfig = {
        //     toolbar: {
        //         items: [
        //             'insertTable',
        //             // other toolbar items
        //         ],
        //     },
        // };


    }

    loadListAttribute(event) {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/attribute/get_attribute_list?" +
            "page=0" +
            "&nrpp=20" +
            "&name=" + event.query);
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    let list: Array<Attribute> = res["entity"];
                    this.attributeList = [];
                    for (let attribute of list) {
                        this.attributeList.push(attribute.name);
                    }

                }
                if (res["status"] == 401) {
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    addToAttributeValList() {
        this.page.attributeValues.push(this.newAttributeValue);
        this.newAttributeValue = new AttributeValue();
    }

    removeAttributeValue(i: number) {
        this.page.attributeValues = this.page.attributeValues.filter(a => a != this.page.attributeValues[i]);
    }

    onReady(eventData) {
        eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
            // console.log(btoa(loader.file));
            // console.log(loader.file);
            return new UploadAdapter(loader);
        };
    }


    addSection() {
        let sec = new PageSection()
        this.page.pageSections.push(sec);
        for (let i = 0; i < this.page.pageSections.length; i++) {
            this.page.pageSections[i].priority = i;
        }
        this.sectionHeaderItems[this.page.pageSections.length - 1] = this.fillItemsMenu(this.page.pageSections.length - 1);
    }

    addNewItem(sectionIndex: number, itemType: string) {
        if (itemType == "TITLE") {
            var pageSection = this.page.pageSections[sectionIndex];
            let item: SectionItem = new SectionItem();
            item.type = "TITLE";
            item.priority = pageSection.items.length + 1;
            pageSection.items.push(item);

        } else if (itemType == "TEXT") {
            var pageSection = this.page.pageSections[sectionIndex];
            let item: SectionItem = new SectionItem();
            item.type = "TEXT";
            item.priority = pageSection.items.length + 1;
            pageSection.items.push(item);
            // setTimeout(() => {
            //     this.editorBO = new EditorBO();
            //     this.suneitor_Text?.setOptions(this.editorBO.editorOptions);
            // }, 10);

        } else if (itemType == "SEPARATOR") {
            var pageSection = this.page.pageSections[sectionIndex];
            let item: SectionItem = new SectionItem();
            item.type = "SEPARATOR";
            item.priority = pageSection.items.length + 1;
            pageSection.items.push(item);

        } else if (itemType == "PHOTO") {
            this.selectPhotoType = "photo";
            this.displayImageCenter = true;

        } else if (itemType == "VIDEO") {
            this.selectedSection = this.page.pageSections[sectionIndex];
            this.displayVideoCenter = true;

        } else if (itemType == "INNER") {
            this.selectedSection = this.page.pageSections[sectionIndex];
            this.displayInnerHtml = true;

        } else if (itemType == "AUTHOR") {
            var pageSection = this.page.pageSections[sectionIndex];
            let item: SectionItem = new SectionItem();
            item.type = "AUTHOR";
            item.body.set("imgUid", "");
            item.body.set("name", "");
            item.body.set("desc", "");
            item.priority = pageSection.items.length + 1;
            pageSection.items.push(item);

        } else if (itemType == "HTML") {
            var pageSection = this.page.pageSections[sectionIndex];
            let item: SectionItem = new SectionItem();
            item.type = "HTML";
            item.body['code'] = "<p></p>";
            item.priority = pageSection.items.length + 1;
            pageSection.items.push(item);

        } else if (itemType == "ACCORDION") {
            var pageSection = this.page.pageSections[sectionIndex];
            let item: SectionItem = new SectionItem();
            item.type = "ACCORDION";
            item.priority = pageSection.items.length + 1;
            pageSection.items.push(item);

        }
        // console.log(this.page.pageSections);
    }

    changEditText(item: SectionItem, suneitor_Text: NgxSuneditorComponent) {
        // item.body["text"] = suneitor_Text.getContents(false);
        const textarea: HTMLInputElement = suneitor_Text ? suneitor_Text.save(false) as HTMLInputElement : new HTMLInputElement();
        item.body["text"] = textarea.value;
    }

    selectPhotoItem(uploadFile: UploadFile) {
        if (this.selectPhotoType == "photo") {
            var pageSection = this.page.pageSections[this.selectedSection.priority];
            let item: SectionItem = new SectionItem();
            item.type = "PHOTO";
            item.priority = pageSection.items.length + 1;
            item.body["imgUid"] = uploadFile.uid;
            item.body["name"] = uploadFile.name;
            pageSection.items.push(item);
        } else if (this.selectPhotoType == "author") {
            this.selectedSection.items[this.sectionItemIndex].body["imgUid"] = uploadFile.uid;
        } else if (this.selectPhotoType == "bgImage") {
            this.page.style.bgImage = uploadFile.uid;
        } else if (this.selectPhotoType == "logoImage") {
            this.page.style.logoImage = uploadFile.uid;
        } else if (this.selectPhotoType == "wLogoImage") {
            this.page.style.w_logo_image = uploadFile.uid;
        } else if (this.selectPhotoType == "title") {
            this.selectedSection.items[this.sectionItemIndex].body["imgUid"] = uploadFile.uid;
        }
        this.displayImageCenter = false;


    }

    deleteSection(section: PageSection) {
        this.page.pageSections = this.page.pageSections.filter(s => s != section);
        let i = 1;
        for (let sec of this.page.pageSections) {
            sec.priority = i;
            i++;
        }
    }

    deleteItem(section: PageSection, item: SectionItem) {
        section.items = section.items.filter(i => i != item);
        let i = 1;
        for (let item1 of section.items) {
            item1.priority = i;
            i++;
        }
    }

    editItems( item: SectionItem) {
        if (item.type == "INNER") {
            this.htmlCode = item.body["code"];
            this.displayInnerHtml = true;
        }
        this.editItem=item;


    }

    downSection(section: PageSection) {
        let temp = new Array<PageSection>()
        for (let i = 0; i < this.page.pageSections.length; i++) {
            if (this.page.pageSections[i] == section) {
                temp[i + 1] = this.page.pageSections[i];
                temp[i] = this.page.pageSections[i + 1];
                i++
            } else {
                temp[i] = this.page.pageSections[i];
            }
        }
        this.page.pageSections = temp;
        for (let i = 0; i < this.page.pageSections.length; i++) {
            this.page.pageSections[i].priority = i;
        }

    }

    upSection(section: PageSection) {
        let temp = new Array<PageSection>()
        for (let i = 0; i < this.page.pageSections.length; i++) {
            if (this.page.pageSections[i] == section) {
                temp[i - 1] = this.page.pageSections[i];
                temp[i] = this.page.pageSections[i - 1];
            } else {
                temp[i] = this.page.pageSections[i];
            }
        }
        this.page.pageSections = temp;
        for (let i = 0; i < this.page.pageSections.length; i++) {
            this.page.pageSections[i].priority = i;
        }
    }

    downItem(sectionIndex, item: SectionItem) {
        let temp = new Array<SectionItem>()
        for (let i = 0; i < this.page.pageSections[sectionIndex].items.length; i++) {
            if (this.page.pageSections[sectionIndex].items[i] == item) {
                temp[i] = this.page.pageSections[sectionIndex].items[i + 1];
                temp[i + 1] = this.page.pageSections[sectionIndex].items[i];
                i++;
            } else {
                temp[i] = this.page.pageSections[sectionIndex].items[i];
            }
        }
        this.page.pageSections[sectionIndex].items = temp;
    }

    upItem(sectionIndex, item: SectionItem) {
        let temp = new Array<SectionItem>()
        for (let i = 0; i < this.page.pageSections[sectionIndex].items.length; i++) {
            if (this.page.pageSections[sectionIndex].items[i] == item) {
                temp[i - 1] = this.page.pageSections[sectionIndex].items[i];
                temp[i] = this.page.pageSections[sectionIndex].items[i - 1];
            } else {
                temp[i] = this.page.pageSections[sectionIndex].items[i];
            }
        }
        this.page.pageSections[sectionIndex].items = temp;

    }

    addVideo() {
        var pageSection = this.selectedSection;
        let item: SectionItem = new SectionItem();
        item.type = "VIDEO";
        item.priority = pageSection.items.length + 1;
        item.body["src"] = this.videoSrcTemp;
        pageSection.items.push(item);
        this.displayVideoCenter = false;
        this.videoSrcTemp = '';


    }

    addAuthorImg(section: PageSection, j: number) {
        this.sectionItemIndex = j;
        this.selectedSection = section;
        this.selectPhotoType = "author";
        this.displayImageCenter = true;
    }

    addTitleImg(section: PageSection, j: number) {
        this.sectionItemIndex = j;
        this.selectedSection = section;
        this.selectPhotoType = "title";
        this.displayImageCenter = true;
    }

    htmlCode: string = "";

    addInner() {
        var pageSection = this.selectedSection;
        if(this.editItem == null ||this.editItem.id<1) {
            let item: SectionItem = new SectionItem();
            item.type = "INNER";
            item.priority = pageSection.items.length + 1;
            item.body["code"] = this.htmlCode;
            pageSection.items.push(item);
        }else {
            this.editItem.body["code"] = this.htmlCode;
            this.editItem = null;
        }
        this.displayInnerHtml = false;
        this.htmlCode = '';

    }

    savePage() {

        let params = {};
        for (let pageSection of this.page.pageSections) {
            for (let i = 0; i < pageSection.items.length; i++) {
                pageSection.items[i].priority=i;
            }
        }
        let body = this.page;
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/page/save_page", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'info',
                        summary: $localize`:@@Save_Success:Save Success`,
                        detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                    });
                    this.savePageEvent.emit();

                } else if (res["status"] == 400) {
                    if (res["message"] == "ConflictPageName") {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: $localize`:@@Error:Error`,
                            detail: $localize`:@@Conflict Page Name:Conflict Page Name`,
                            life: 6000
                        });
                    }
                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;


        });
    }

    cancelSavePage() {
        this.cancelSaveEvent.emit();
    }

    addStyleBgImage() {
        this.selectPhotoType = "bgImage";
        this.displayImageCenter = true;
    }

    addStyleLogoImage(type) {
        this.selectPhotoType = type;
        this.displayImageCenter = true;
    }

    loadEditor(content: string, suneitor_Text: NgxSuneditorComponent) {
        suneitor_Text.setOptions(this.editorBO.editorOptions);
        suneitor_Text.setContents(content);
    }


    addAccordion(item: SectionItem) {
        if (item.body['list'] == null) {
            item.body['list'] = [];
        }
        item.body['list'].push(this.accordionTemp);
        this.accordionTemp = {};
    }

    removeAccordionFromList(item: SectionItem, i: number) {
        item.body['list'].splice(i, 1);
    }



    accessEditIcon(item: SectionItem):boolean {
        if (item.type == "INNER") {
            return true;
        }else {
            return  false;
        }
    }
}
